.overlay {
  position: fixed;
  inset: 0;
  z-index: var(--z-overlay);
  background: var(--color-scrim);
  animation: fade var(--duration-base) var(--ease-standard);
}

.content {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: var(--z-dialog);
  display: flex;
  flex-direction: column;
  width: calc(100vw - 2 * var(--space-6));
  max-height: min(86dvh, 820px);
  border-radius: var(--radius-xl);
  background: var(--color-surface-raised);
  box-shadow: var(--shadow-lg);
  transform: translate(-50%, -50%);
  animation: rise var(--duration-base) var(--ease-standard);
  outline: none;
}

.sm {
  max-width: 420px;
}

.md {
  max-width: var(--dialog-width);
}

.lg {
  max-width: 640px;
}

.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-4);
  padding: var(--space-5) var(--space-5) var(--space-2) var(--space-6);
}

.heading {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-width: 0;
  padding-top: var(--space-1);
}

.title {
  font-size: var(--text-xl);
  font-weight: var(--weight-semibold);
  line-height: var(--leading-snug);
  overflow-wrap: anywhere;
}

.description {
  color: var(--color-text-muted);
  font-size: var(--text-sm);
}

.body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: var(--space-3) var(--space-6) var(--space-6);
}

.footer {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: var(--space-2);
  padding: var(--space-4) var(--space-6);
  border-top: var(--border-width) solid var(--color-border);
}

@keyframes fade {
  from {
    opacity: 0;
  }
}

@keyframes rise {
  from {
    opacity: 0;
    transform: translate(-50%, calc(-50% + 8px)) scale(0.98);
  }
}
